import { Ocupante } from "./Ocupante";

export default Ocupante